"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.client = void 0;
var graphql_request_1 = require("graphql-request");
var sdk_1 = require("./generated/sdk");
var graphqlEndpoint_1 = require("./graphqlEndpoint");
exports.client = (0, sdk_1.getSdk)(new graphql_request_1.GraphQLClient(graphqlEndpoint_1.graphqlEndpoint));
exports.default = exports.client;
